import { SummitFormattedText } from '@summit/models';
import { EboNameObjectTO } from '../../base-classes/ebo-name-object-to';
import { RouteGroupRoute } from './route-group-route';

export class RouteGroup extends EboNameObjectTO {
  groupRoutes: RouteGroupRoute[];

  constructor(data: Partial<RouteGroup>) {
    super(data);
    if (data) {
      if (data.groupRoutes) {
        this.groupRoutes = data.groupRoutes.map((gr) => new RouteGroupRoute(gr));
      }
    }
    this.groupRoutes ??= [];
  }

  get routeNames(): SummitFormattedText {
    const response = new SummitFormattedText();
    this.groupRoutes?.forEach((gr) => {
      response.AddLine(gr.route.name);
    });
    return response;
  }
  set routeNames(value: SummitFormattedText) {
    // Do nothing
  }
}
